<template>
<div>
    <!-- 分享店铺产品 -->
    <div class="flex items-center mt-4">
        <el-button v-if="!isInShop && isOpenShop" type="primary" class="min-w-[140px] rounded-md px-4" icon="ficon ficon-dianpuguanlishuju" @click="$emit('join')">
            <span class="ml-3">加入店铺</span>
        </el-button>
        <nuxt-link to="/topic/shop-tool" target="_blank"
            class="el-button !border-primary rounded-md min-w-[140px] px-4 el-button--primary is-plain plain_blue_btn">
            <span class="ml-[6px]">玩转店铺赚大钱</span>
            <i class="ficon ficon-arrow-right"></i>
        </nuxt-link>
        <div class="ml-4">
            <div class="product__title__action" v-if="status !== 0">
                <el-tooltip placement="bottom-start" popper-class="p-5">
                    <template #content>
                        <p v-html="shareTooltipOptions.content" />
                    </template>
                    <span @click="$emit('share')" class="transition-colors hover:text-primary">
                        <i class="product__title__icon ficon ficon-fenxiang"></i>
                        分享
                    </span>
                </el-tooltip>
                <span class="product__title__split"></span>
                <span @click="$emit('favorite')" class="transition-colors hover:text-primary" :class="{ 'product__title--active': isFavorite }">
                    <span class="product__title__icon">
                    <i class="ficon" :class="{
                        'ficon-shoucangmoren': !isFavorite,
                        'ficon-yishoucang': isFavorite
                    }" />
                    </span>
                    {{ isFavorite ? "已收藏" : "收藏" }}
                </span>
            </div>
        </div>
    </div>

</div>
</template>

<script>

import {ref,computed, toRef, defineComponent,useContext,watch,useRoute } from "@nuxtjs/composition-api";


export default defineComponent({
    // components:{ ShareShopProduct },
    props:{
        title:String,
		isFavorite: Boolean,
		isInShop: Boolean,
        isOpenShop: Boolean,
		status:Number
    },
    emits: ['share', 'favorite', 'join'],
    setup (props) {
        // const route = useRoute();
        // const productNo = toRef(route.value.params, "productNo");
        // ======================= 收藏 =======================
        // const { isFavorite, onToggleFavorite } = useProductFavorite(productNo, !!props.is_favorite)

        // ======================= 分享 =======================
        // const shareShopProductRef = ref(null);
        // const handleShareShopProduct = () => {
        //     shareShopProductRef.value.handleShareShopPrdouct({title:props.title,product_no: productNo.value});
        // }

        // ======================= 加入店铺 =======================
        const {store} = useContext();
        const isDistributor = computed(() => store.getters.isDistributor);
        const isAdmin = computed(() => store.getters.isAdmin)
        // const isOpenShop = computed(() => store.getters.isOpenShop)
        // const { isInShop,onJoinShop } = useProductJoinShop(productNo);

        const shareTooltipOptions = ref({
            content:"1.一键下载产品海报或复制产品链接，分享给客人无需<br/>下载任何软件，直接点看查看产品信息，方便又快捷。<br/><br/>2.产品对外分享仅展示零售价，并只展示您店铺的信息<br/>及联系方式，不会露出任何关于平台的元素。",
            trigger: "hover",
            classes: "shareHover",
            offset: "5px"
        });

        // watch(
		// 	() => [props.is_favorite, props.in_shop],
		// 	() => {
		// 		isFavorite.value = !!props.is_favorite;
		// 		isInShop.value = !!props.in_shop;
		// 	},
		// 	{
		// 		immediate: true
		// 	}
		// );
        return {
            // shareShopProductRef,
            // isFavorite,
            // onToggleFavorite,
            // handleShareShopProduct,
            isDistributor,
            isAdmin,
            // isOpenShop,
            // isInShop,
            // onJoinShop,
            shareTooltipOptions
        }
    }
})
</script>

<style lang="scss" scoped>
.product-title {
  font-size: 20px;
  font-weight: 500;
  color: $important-text-color;
}
.product__title--active {
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
.product__title__icon {
  margin-right: 5px;
}
.product__title__split {
  border-right: 1px solid #d8d8d8;
  margin: 0 10px;
  width: 1px;
  height: 1em;
  background-color: #d8d8d8;
}
.product__title__action {
  display: flex;
  align-items: center;
  height: 34px;
  padding: 0 14px;
  border-radius: 34px;
  border: 1px solid #D4D7DE;
  background: #fff;
}
.product__title__action span {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}
.el-button--primary.is-plain {
  background: rgba(0,94,220,0.06) !important;
}
.plain_blue_btn:hover {
  border-color: #337ee3 !important;
  color: #337ee3 !important;
}
</style>
